import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import Link from './Link.js';
import Icon from '../Icon/Icon.js';
import { jsx } from 'react/jsx-runtime';
import { ICON_UI_CHEVRON_UP } from '../../icons/ICON_UI_CHEVRON_UP.js';
import { ICON_UI_CHEVRON_DOWN } from '../../icons/ICON_UI_CHEVRON_DOWN.js';

var _excluded = ["children", "isOpen", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ExpandableLink = function ExpandableLink(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var iconPath = isOpen ? ICON_UI_CHEVRON_UP : ICON_UI_CHEVRON_DOWN;
  return /*#__PURE__*/jsx(Link, _objectSpread(_objectSpread({
    ariaExpanded: isOpen,
    iconAfter: /*#__PURE__*/jsx(Icon, {
      path: iconPath
    }),
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
};
var ExpandableLink$1 = ExpandableLink;

export { ExpandableLink$1 as default };
//# sourceMappingURL=ExpandableLink.js.map
